/**
 * EducationTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const EducationTab = ({ ctx }) => {
  const {
    formData,
    handleEducationChange,
  } = ctx;

  return (
          <TabsContent value="education">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <GraduationCap className="w-5 h-5 text-stone-700" />
                  Education & Qualifications
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Degree/Qualification</Label>
                    <Input
                      value={formData.education[0]?.degree}
                      onChange={(e) => handleEducationChange(0, 'degree', e.target.value)}
                      placeholder="Bachelor of Technology"
                    />
                  </div>
                  <div>
                    <Label>Institution</Label>
                    <Input
                      value={formData.education[0]?.institution}
                      onChange={(e) => handleEducationChange(0, 'institution', e.target.value)}
                      placeholder="University Name"
                    />
                  </div>
                  <div>
                    <Label>Field of Study</Label>
                    <Input
                      value={formData.education[0]?.field_of_study}
                      onChange={(e) => handleEducationChange(0, 'field_of_study', e.target.value)}
                      placeholder="Computer Science"
                    />
                  </div>
                  <div>
                    <Label>Grade/CGPA</Label>
                    <Input
                      value={formData.education[0]?.grade}
                      onChange={(e) => handleEducationChange(0, 'grade', e.target.value)}
                      placeholder="8.5 CGPA"
                    />
                  </div>
                  <div>
                    <Label>Start Date</Label>
                    <Input
                      type="date"
                      value={formData.education[0]?.start_date}
                      onChange={(e) => handleEducationChange(0, 'start_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>End Date</Label>
                    <Input
                      type="date"
                      value={formData.education[0]?.end_date}
                      onChange={(e) => handleEducationChange(0, 'end_date', e.target.value)}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default EducationTab;
